import React from 'react';

const ProcessSection = () => {
  return (
    <section id="process" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-slate-900 mb-4">
            Notre Approche
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            Une méthodologie éprouvée pour votre succès
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          <div className="relative">
            <div className="p-8 rounded-2xl bg-orcsys-50/50 border border-orcsys-100 hover:border-orcsys-200 transition-colors duration-300">
              <div className="w-12 h-12 rounded-full bg-orcsys-500 text-white flex items-center justify-center text-xl font-bold mb-6">
                1
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-3">Discovery & MVP</h3>
              <p className="text-slate-600 leading-relaxed">
                Analyse de vos besoins, conception de l'architecture et développement d'un MVP fonctionnel.
              </p>
            </div>
          </div>
          <div className="relative">
            <div className="p-8 rounded-2xl bg-orcsys-50/50 border border-orcsys-100 hover:border-orcsys-200 transition-colors duration-300">
              <div className="w-12 h-12 rounded-full bg-orcsys-500 text-white flex items-center justify-center text-xl font-bold mb-6">
                2
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-3">Développement Agile</h3>
              <p className="text-slate-600 leading-relaxed">
                Itérations rapides, feedback continu et ajustements en temps réel pour un produit optimal.
              </p>
            </div>
          </div>
          <div className="relative">
            <div className="p-8 rounded-2xl bg-orcsys-50/50 border border-orcsys-100 hover:border-orcsys-200 transition-colors duration-300">
              <div className="w-12 h-12 rounded-full bg-orcsys-500 text-white flex items-center justify-center text-xl font-bold mb-6">
                3
              </div>
              <h3 className="text-xl font-semibold text-slate-900 mb-3">Lancement & Support</h3>
              <p className="text-slate-600 leading-relaxed">
                Déploiement, monitoring et support continu pour assurer votre succès.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection; 